module.exports = "/_next/static/videos/skiing-3-b7c4f0dc8f7bebb0025ce9d3ffa0a8af.webm";